import WhyTeamsPrefer from "../Pricing/WhyTeamsPrefer";
import "./Industries.css";

const Industries = () => {
  return (
    <>
      <div className="industries-container">
        <h1 className="industries-title">Industries</h1>

        <div className="industries-cards">
          <div className="industries-card">
            <img
              src="/assets/Industries/carehomes.png"
              alt="carehomes"
              className="industries-icon"
            />
            <h3>Assisted Living & Care Homes</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/agri.png"
              alt="agri"
              className="industries-icon"
            />
            <h3>Agribusiness & Farming</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/biotech.png"
              alt="biotech"
              className="industries-icon"
            />
            <h3>Biotech & Life Sciences</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/produt.png"
              alt="products"
              className="industries-icon"
            />
            <h3>Consumer Products</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/education.png"
              alt="education"
              className="industries-icon"
            />
            <h3>Education</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/utili.png"
              alt="utilities"
              className="industries-icon"
            />
            <h3>Energy & Utilities</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/food.png"
              alt="food"
              className="industries-icon"
            />
            <h3>Food & Beverage</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/finacial.png"
              alt="finance"
              className="industries-icon"
            />
            <h3>Financial & Professional Services</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/hotels.png"
              alt="hotels"
              className="industries-icon"
            />
            <h3>Hotels</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/healthcare.png"
              alt="healthcare"
              className="industries-icon"
            />
            <h3>Health Care</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/construcntion.png"
              alt="construction"
              className="industries-icon"
            />
            <h3>Infrastructure Development & Technical Design</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/logistics.png"
              alt="logistics"
              className="industries-icon"
            />
            <h3>Logistics & Transportation</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/manufactures.png"
              alt="manufacturing"
              className="industries-icon"
            />
            <h3>Manufacturing</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/media.png"
              alt="media"
              className="industries-icon"
            />
            <h3>Media & Communications</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/nonprofit.png"
              alt="nonprofit"
              className="industries-icon"
            />
            <h3>Non-Profit</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/public.png"
              alt="public"
              className="industries-icon"
            />
            <h3>Public Sector</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/retail.png"
              alt="retail"
              className="industries-icon"
            />
            <h3>Retail</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/realestate.png"
              alt="realestate"
              className="industries-icon"
            />
            <h3>Real Estate & Facility Management</h3>
          </div>

          <div className="industries-card">
            <img
              src="/assets/Industries/tech.png"
              alt="tech"
              className="industries-icon"
            />
            <h3>Technology & Software</h3>
          </div>
        </div>
      </div>
      <WhyTeamsPrefer
        title="Get in touch to discuss your business requirements and arrange a demo."
        buttonLabel="Book a custom demo"
      />
    </>
  );
};

export default Industries;
